import React from "react";
import { Route, Router, Switch } from "wouter";
import AdminLogIn from "../admin/screens/adminLogin";
import AdminForgotPassword from "../admin/screens/adminForgotPassword";
import AdminResetPassword from "../admin/screens/adminResetPassword";

const ErrorScreen = React.lazy(() => import("../404"));

const AuthRoutes = () => {
  return (
    <Router>
      <React.Suspense>
        <Switch>
          <Route exact path="/admin/login" component={AdminLogIn} />
          <Route
            exact
            path="/admin/forgot-password"
            component={AdminForgotPassword}
          />
          <Route path="/admin/reset-password" component={AdminResetPassword} />
          {/* if none of the route is matched */}
          <Route component={ErrorScreen} />
        </Switch>
      </React.Suspense>
    </Router>
  );
};

export default AuthRoutes;
